import { ICustomOption, IFieldFilter, ISearchFilter } from '@/models/filters/Filters';
import { CrudModule, IModuleState } from '@/store/entityModules/CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { Font } from '@/models/entities/Font';
import { FontDTO } from '@/api/dto/FontDTO';
import { ActionTree, GetterTree } from 'vuex';
import { getEntityApiClient } from '@/api/utils/GetClient';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { AlertColor, chooseErrorMessageData, dispatchAlert } from '@/utils/alerts';
import { QueryFilters } from '@/models/filters/QueryFilters';

class FontsModule extends CrudModule<Font, FontDTO> {
  state: IModuleState<Font, FontDTO> = {
    ...this.state,
    queryFilters: new QueryFilters({ sortFilter: { descending: false, sortBy: 'name' } }),
    entityType: EntityType.FONT,
    customFilteredItems: [],
    customLoading: false,
    customFilters: new SearchQueryFilters({ page: 1, rowsPerPage: 20 }),
  };

  getters: GetterTree<IModuleState<Font, FontDTO>, any> = {
    ...this.getters,

    customFilteredItems(state): Font[] | undefined {
      return state.customFilteredItems;
    },
  };

  actions: ActionTree<IModuleState<Font, FontDTO>, any> = {
    ...this.actions,

    setCustomFiltersNextPage({ state }) {
      if (state.customFilters) state.customFilters.page += 1;
    },

    setCustomFilterField({ state }, filterFields: IFieldFilter) {
      if (state.customFilters && filterFields) {
        state.customFilters.fieldFilter = filterFields;
        state.customFilters.page = 1;
      }
    },

    setCustomInitialValue({ state }, defaultValue: number[] | number) {
      if (defaultValue !== undefined && typeof defaultValue !== 'number')
        defaultValue = defaultValue?.filter(item => item !== undefined);

      if (state.customFilters) {
        if (
          defaultValue !== undefined &&
          (typeof defaultValue === 'number' || defaultValue.length > 0)
        ) {
          if (typeof defaultValue === 'number')
            state.customFilters.initialValue = [defaultValue];
          else state.customFilters.initialValue = defaultValue;
        } else state.customFilters.initialValue = undefined;
      }
    },

    setCustomSearchField({ state }, searchFields: ISearchFilter) {
      if (state.customFilters) {
        state.customFilters.searchFilter = searchFields;
        state.customFilters.page = 1;
      }
    },

    async fetchCustomFilteredItems(
      { state, commit, dispatch },
      {
        startFromPage,
        customOptions,
      }: { startFromPage?: number; customOptions?: ICustomOption[] } = {},
    ) {
      if (startFromPage && startFromPage === 1) state.customFilteredItems = [];

      if (state.customFilters && startFromPage) {
        state.customFilters.page = startFromPage;
      }

      commit('setCustomLoading', true);

      try {
        const apiClient = getEntityApiClient(state.entityType);
        const response = await apiClient.fetchItems(
          state.customFilters || new SearchQueryFilters({}),
          customOptions,
        );
        commit('setCustomFilteredItems', response.items);
      } catch (err) {
        console.error(err);
        if (err instanceof Error) {
          const errorMessage = chooseErrorMessageData(
            {
              entityName: state.entityType,
              action: 'fetch',
            },
            err.message,
          );
          dispatchAlert(AlertColor.ERROR, errorMessage, dispatch);
        }
      } finally {
        commit('setCustomLoading', false);
      }
    },
  };
}

const fontsModule = new FontsModule();
export default fontsModule;
